import "./Counsels.scss"

import React, { memo, useCallback, useEffect, useState } from "react"

import { counselApi } from "@shared/apis"
import { Counsel } from "@shared/apis/counsel"
import { useSchedule } from "@shared/contexts"
import { toHHmmss, toYYYYMMDD } from "@shared/modules"

const INIT_PAGE = 0
const RECENT_COUNSEL_INDEX = 0

function Counsels() {
  const { schedule } = useSchedule()
  const [counsels, setCounsels] = useState<Counsel[]>([])
  const [page, setPage] = useState(0)
  const [totalPage, setTotalPage] = useState(0)

  const getCounsels = useCallback(
    (page: number) => {
      if (!schedule) return

      counselApi
        .get(schedule.id, undefined, page + 1, 30)
        .then(({ data: counsels }) => {
          setCounsels((prevCounsels) => {
            return Array.from(
              new Set(
                [...prevCounsels, ...counsels.content]
                  .filter((counsel) => {
                    return prevCounsels[RECENT_COUNSEL_INDEX]
                      ? counsel.id <= prevCounsels[RECENT_COUNSEL_INDEX].id
                      : true
                  })
                  .map((counsel) => JSON.stringify(counsel)),
              ),
            ).map((counsel) => JSON.parse(counsel))
          })
          setTotalPage(counsels.totalPages)
          setPage(page + 1)
        })
    },
    [schedule],
  )

  useEffect(() => {
    if (!getCounsels || !schedule) return

    getCounsels(INIT_PAGE)
  }, [schedule, getCounsels])

  return (
    <div className="custom counsels">
      <article className="popup">
        <div className="innerB">
          <div className="tableB">
            <table className="center">
              <colgroup>
                <col width="60" />
                <col width="120" />
                <col width="*" />
                <col width="110" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>필명</th>
                  <th>내용</th>
                  <th className="last">신청일시</th>
                </tr>
              </thead>
              <tbody>
                {counsels.length ? (
                  counsels.map((counsel) => (
                    <tr key={counsel.id}>
                      <td>{counsel.id}</td>
                      <td>{counsel.nickname}</td>
                      <td className="txt">{counsel.content}</td>
                      <td className="last">
                        {toYYYYMMDD(counsel.createdAt)}
                        <br />
                        {toHHmmss(counsel.createdAt)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="dataNone">
                      현재 문의받은 내용이 없습니다.
                    </td>
                  </tr>
                )}

                {page < totalPage ? (
                  <tr>
                    <td colSpan={4} className="btnMore">
                      <a
                        href="#!"
                        title="더보기"
                        onClick={(e) => {
                          e.preventDefault()
                          getCounsels(page)
                        }}
                      >
                        <span>더보기</span>
                      </a>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </article>
    </div>
  )
}
export default memo(Counsels)
